jQuery(document).ready(function ($) {
	// ---------- BRAND SLIDER ----------
	function initBrandSlider($block) {
		const $slider = $block.find(".brand-slider");
		if ($slider.hasClass("slick-initialized")) return;
		if (typeof $.fn.slick === "undefined") {
			console.warn("Slick slider not loaded yet for brand-slider");
			return;
		}

		$slider.slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			infinite: true,
			speed: 5000,
			autoplay: true,
			autoplaySpeed: 0,
			cssEase: "linear",
			arrows: false,
			dots: false,
			pauseOnHover: false,
			draggable: false,
			responsive: [{ breakpoint: 768, settings: { slidesToShow: 2 } }],
		});
	}

	$(".brand-slider-block").each(function () {
		initBrandSlider($(this));
	});

	// Support ACF block previews if using Advanced Custom Fields
	if (window.acf) {
		window.acf.addAction(
			"render_block_preview/type=brand-slider",
			initBrandSlider,
		);
	}
});
